<template>
    <div class="page-container">
        <!-- 智能产品 -->
        <div class="smart-container">
            <div class="matrix-header">
                <h2>经典案例</h2>
            </div>
            <div class="smart-wrapper">
                <el-row class="smart-row" :gutter="30">
                    <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" :xxl="8" class="smart-item" v-for="item in smart"
                        :key="item.title">
                        <div class="smart-card">
                            <div class="smart-image-container">
                                <img :src="item.image" class="smart-image" :alt="item.title">
                            </div>
                            <div class="smart-text-content">
                                <div class="divider"></div>
                                <h5 class="smart-title" @click="goToTypicalcase(item.path)">{{ item.title }}
                                    <img src="@/assets/images/MainTypicalcase/jiantou.png" alt="箭头图标"
                                        class="title-icon">
                                </h5>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MainHomepage',
    data() {
        return {
            smart: [
                {
                    title: '宁夏彭阳县2024年冷凉蔬菜数字农业示范基地项目',
                    image: require('@/assets/images/MainTypicalcase/llsc.png'),
                    path: '/pysznyDetails'

                },
                {
                    title: '宁夏5G设施智慧农业试点建设项目',
                    image: require('@/assets/images/MainTypicalcase/zhny.png'),
                    path: '/zhnyDetails'

                },
                {
                    title: '宁夏古城镇温沟村日光温室示范园区自动化项目',
                    image: require('@/assets/images/MainTypicalcase/wszdh.png'),
                    path: '/gczrgwsDetails'

                },
                {
                    title: '宁夏银川西夏区富宁村数字智慧温棚建设项目',
                    image: require('@/assets/images/MainTypicalcase/zhwp.png'),
                    path: '/funingcunDetails'

                },
                {
                    title: '固原市西吉县旺吉农业2024年冷凉蔬菜农业示范基地项目',
                    image: require('@/assets/images/MainTypicalcase/xjllsc.png'),
                    path: '/xijixianDetails'
                },
                {
                    title: '云南红河建水县水田宇园阳光玫瑰葡萄园智慧园区项目',
                    image: require('@/assets/images/MainTypicalcase/ygpt.png'),
                    path: '/yunnanhhDetails'

                },

            ]
        }
    },
    methods: {
        goToTypicalcase(path) {
            this.$router.push(path);
        }
    }
}
</script>

<style scoped>
.page-container {
    width: 100%;
    background-color: rgba(216, 216, 216, 0.2);
    overflow-x: hidden;
}

.matrix-header {
    text-align: center;
    margin-bottom: 64px;
}

.matrix-header h2 {
    text-align: center;
    margin-bottom: 16px;
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 32px;
    font-weight: 600;
    line-height: 36px;
    color: #111827;
}

.smart-container {
    width: 100%;
    max-width: 1920px;
    padding: 10px 20px 60px;
    box-sizing: border-box;
    margin: 0 auto;
}

.smart-wrapper {
    width: 100%;
    margin: 0 auto;
}

.smart-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    box-sizing: border-box;
    justify-content: center;
    margin: 0 !important;
}

.smart-item {
    box-sizing: border-box;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
}

.smart-card {
    background-color: #ffffff;
    border-radius: 0.5rem;
    padding: 24px 0;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
    transition: box-shadow 150ms cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    max-width: 650px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

.smart-card:hover {
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.smart-image-container {
    width: 100%;
    height: 280px;
    border-radius: 0.5rem;
    overflow: hidden;
    margin-bottom: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.smart-image {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
}

.smart-text-content {
    width: 100%;
    box-sizing: border-box;
    flex: 1;
    display: flex;
    flex-direction: column;
}

.divider {
    height: 1px;
    background-color: #2563EB;
    width: 100%;
}

.smart-title {
    font-family: 'Alibaba_PuHuiTi_2.0_55_Regular_55_Regular';
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    color: #111827;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    margin: 20px 5px;
}

.title-icon {
    width: 20px;
    height: 20px;
    margin-left: auto;
    vertical-align: middle;
}

/* 手机设备样式 (小于768px) */
@media (max-width: 767px) {
    .matrix-header {
        margin-bottom: 40px;
    }

    .matrix-header h2 {
        font-size: 24px;
        line-height: 32px;
    }

    .smart-container {
        padding: 10px 15px 40px;
    }

    .smart-image-container {
        height: 200px;
    }

    .smart-title {
        font-size: 16px;
        line-height: 22px;
    }

    .title-icon {
        width: 16px;
        height: 16px;
    }
}

/* 平板设备样式 (768px - 1023px) */
@media (min-width: 768px) and (max-width: 1023px) {
    .matrix-header h2 {
        font-size: 28px;
        line-height: 34px;
    }

    .smart-image-container {
        height: 240px;
    }
}

/* 大屏幕设备样式 (2560px - 3839px) */
@media (min-width: 2560px) and (max-width: 3839px) {
    .smart-container {
        max-width: 2400px;
        padding: 20px 30px 80px;
    }

    .matrix-header {
        margin-bottom: 80px;
    }

    .matrix-header h2 {
        font-size: 42px;
        line-height: 48px;
    }

    .smart-card {
        padding: 32px 0;
    }

    .smart-image-container {
        height: 360px;
    }

    .smart-title {
        font-size: 24px;
        line-height: 32px;
    }

    .title-icon {
        width: 28px;
        height: 28px;
    }
}

/* 超大型屏幕设备样式 (3840px及以上) */
@media (min-width: 3840px) {
    .smart-container {
        max-width: 3200px;
        padding: 20px 40px 100px;
    }

    .matrix-header {
        margin-bottom: 100px;
    }

    .matrix-header h2 {
        font-size: 52px;
        line-height: 60px;
    }

    .smart-card {
        padding: 40px 0;
    }

    .smart-image-container {
        height: 450px;
    }

    .smart-title {
        font-size: 30px;
        line-height: 40px;
    }

    .title-icon {
        width: 32px;
        height: 32px;
    }
}
</style>